function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _decorate(decorators, factory, superClass, mixins) { var api = _getDecoratorsApi(); if (mixins) { for (var i = 0; i < mixins.length; i++) { api = mixins[i](api); } } var r = factory(function initialize(O) { api.initializeInstanceElements(O, decorated.elements); }, superClass); var decorated = api.decorateClass(_coalesceClassElements(r.d.map(_createElementDescriptor)), decorators); api.initializeClassElements(r.F, decorated.elements); return api.runClassFinishers(r.F, decorated.finishers); }

function _getDecoratorsApi() { _getDecoratorsApi = function () { return api; }; var api = { elementsDefinitionOrder: [["method"], ["field"]], initializeInstanceElements: function (O, elements) { ["method", "field"].forEach(function (kind) { elements.forEach(function (element) { if (element.kind === kind && element.placement === "own") { this.defineClassElement(O, element); } }, this); }, this); }, initializeClassElements: function (F, elements) { var proto = F.prototype; ["method", "field"].forEach(function (kind) { elements.forEach(function (element) { var placement = element.placement; if (element.kind === kind && (placement === "static" || placement === "prototype")) { var receiver = placement === "static" ? F : proto; this.defineClassElement(receiver, element); } }, this); }, this); }, defineClassElement: function (receiver, element) { var descriptor = element.descriptor; if (element.kind === "field") { var initializer = element.initializer; descriptor = { enumerable: descriptor.enumerable, writable: descriptor.writable, configurable: descriptor.configurable, value: initializer === void 0 ? void 0 : initializer.call(receiver) }; } Object.defineProperty(receiver, element.key, descriptor); }, decorateClass: function (elements, decorators) { var newElements = []; var finishers = []; var placements = { static: [], prototype: [], own: [] }; elements.forEach(function (element) { this.addElementPlacement(element, placements); }, this); elements.forEach(function (element) { if (!_hasDecorators(element)) return newElements.push(element); var elementFinishersExtras = this.decorateElement(element, placements); newElements.push(elementFinishersExtras.element); newElements.push.apply(newElements, elementFinishersExtras.extras); finishers.push.apply(finishers, elementFinishersExtras.finishers); }, this); if (!decorators) { return { elements: newElements, finishers: finishers }; } var result = this.decorateConstructor(newElements, decorators); finishers.push.apply(finishers, result.finishers); result.finishers = finishers; return result; }, addElementPlacement: function (element, placements, silent) { var keys = placements[element.placement]; if (!silent && keys.indexOf(element.key) !== -1) { throw new TypeError("Duplicated element (" + element.key + ")"); } keys.push(element.key); }, decorateElement: function (element, placements) { var extras = []; var finishers = []; for (var decorators = element.decorators, i = decorators.length - 1; i >= 0; i--) { var keys = placements[element.placement]; keys.splice(keys.indexOf(element.key), 1); var elementObject = this.fromElementDescriptor(element); var elementFinisherExtras = this.toElementFinisherExtras((0, decorators[i])(elementObject) || elementObject); element = elementFinisherExtras.element; this.addElementPlacement(element, placements); if (elementFinisherExtras.finisher) { finishers.push(elementFinisherExtras.finisher); } var newExtras = elementFinisherExtras.extras; if (newExtras) { for (var j = 0; j < newExtras.length; j++) { this.addElementPlacement(newExtras[j], placements); } extras.push.apply(extras, newExtras); } } return { element: element, finishers: finishers, extras: extras }; }, decorateConstructor: function (elements, decorators) { var finishers = []; for (var i = decorators.length - 1; i >= 0; i--) { var obj = this.fromClassDescriptor(elements); var elementsAndFinisher = this.toClassDescriptor((0, decorators[i])(obj) || obj); if (elementsAndFinisher.finisher !== undefined) { finishers.push(elementsAndFinisher.finisher); } if (elementsAndFinisher.elements !== undefined) { elements = elementsAndFinisher.elements; for (var j = 0; j < elements.length - 1; j++) { for (var k = j + 1; k < elements.length; k++) { if (elements[j].key === elements[k].key && elements[j].placement === elements[k].placement) { throw new TypeError("Duplicated element (" + elements[j].key + ")"); } } } } } return { elements: elements, finishers: finishers }; }, fromElementDescriptor: function (element) { var obj = { kind: element.kind, key: element.key, placement: element.placement, descriptor: element.descriptor }; var desc = { value: "Descriptor", configurable: true }; Object.defineProperty(obj, Symbol.toStringTag, desc); if (element.kind === "field") obj.initializer = element.initializer; return obj; }, toElementDescriptors: function (elementObjects) { if (elementObjects === undefined) return; return _toArray(elementObjects).map(function (elementObject) { var element = this.toElementDescriptor(elementObject); this.disallowProperty(elementObject, "finisher", "An element descriptor"); this.disallowProperty(elementObject, "extras", "An element descriptor"); return element; }, this); }, toElementDescriptor: function (elementObject) { var kind = String(elementObject.kind); if (kind !== "method" && kind !== "field") { throw new TypeError('An element descriptor\'s .kind property must be either "method" or' + ' "field", but a decorator created an element descriptor with' + ' .kind "' + kind + '"'); } var key = _toPropertyKey(elementObject.key); var placement = String(elementObject.placement); if (placement !== "static" && placement !== "prototype" && placement !== "own") { throw new TypeError('An element descriptor\'s .placement property must be one of "static",' + ' "prototype" or "own", but a decorator created an element descriptor' + ' with .placement "' + placement + '"'); } var descriptor = elementObject.descriptor; this.disallowProperty(elementObject, "elements", "An element descriptor"); var element = { kind: kind, key: key, placement: placement, descriptor: Object.assign({}, descriptor) }; if (kind !== "field") { this.disallowProperty(elementObject, "initializer", "A method descriptor"); } else { this.disallowProperty(descriptor, "get", "The property descriptor of a field descriptor"); this.disallowProperty(descriptor, "set", "The property descriptor of a field descriptor"); this.disallowProperty(descriptor, "value", "The property descriptor of a field descriptor"); element.initializer = elementObject.initializer; } return element; }, toElementFinisherExtras: function (elementObject) { var element = this.toElementDescriptor(elementObject); var finisher = _optionalCallableProperty(elementObject, "finisher"); var extras = this.toElementDescriptors(elementObject.extras); return { element: element, finisher: finisher, extras: extras }; }, fromClassDescriptor: function (elements) { var obj = { kind: "class", elements: elements.map(this.fromElementDescriptor, this) }; var desc = { value: "Descriptor", configurable: true }; Object.defineProperty(obj, Symbol.toStringTag, desc); return obj; }, toClassDescriptor: function (obj) { var kind = String(obj.kind); if (kind !== "class") { throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator' + ' created a class descriptor with .kind "' + kind + '"'); } this.disallowProperty(obj, "key", "A class descriptor"); this.disallowProperty(obj, "placement", "A class descriptor"); this.disallowProperty(obj, "descriptor", "A class descriptor"); this.disallowProperty(obj, "initializer", "A class descriptor"); this.disallowProperty(obj, "extras", "A class descriptor"); var finisher = _optionalCallableProperty(obj, "finisher"); var elements = this.toElementDescriptors(obj.elements); return { elements: elements, finisher: finisher }; }, runClassFinishers: function (constructor, finishers) { for (var i = 0; i < finishers.length; i++) { var newConstructor = (0, finishers[i])(constructor); if (newConstructor !== undefined) { if (typeof newConstructor !== "function") { throw new TypeError("Finishers must return a constructor."); } constructor = newConstructor; } } return constructor; }, disallowProperty: function (obj, name, objectType) { if (obj[name] !== undefined) { throw new TypeError(objectType + " can't have a ." + name + " property."); } } }; return api; }

function _createElementDescriptor(def) { var key = _toPropertyKey(def.key); var descriptor; if (def.kind === "method") { descriptor = { value: def.value, writable: true, configurable: true, enumerable: false }; } else if (def.kind === "get") { descriptor = { get: def.value, configurable: true, enumerable: false }; } else if (def.kind === "set") { descriptor = { set: def.value, configurable: true, enumerable: false }; } else if (def.kind === "field") { descriptor = { configurable: true, writable: true, enumerable: true }; } var element = { kind: def.kind === "field" ? "field" : "method", key: key, placement: def.static ? "static" : def.kind === "field" ? "own" : "prototype", descriptor: descriptor }; if (def.decorators) element.decorators = def.decorators; if (def.kind === "field") element.initializer = def.value; return element; }

function _coalesceGetterSetter(element, other) { if (element.descriptor.get !== undefined) { other.descriptor.get = element.descriptor.get; } else { other.descriptor.set = element.descriptor.set; } }

function _coalesceClassElements(elements) { var newElements = []; var isSameElement = function (other) { return other.kind === "method" && other.key === element.key && other.placement === element.placement; }; for (var i = 0; i < elements.length; i++) { var element = elements[i]; var other; if (element.kind === "method" && (other = newElements.find(isSameElement))) { if (_isDataDescriptor(element.descriptor) || _isDataDescriptor(other.descriptor)) { if (_hasDecorators(element) || _hasDecorators(other)) { throw new ReferenceError("Duplicated methods (" + element.key + ") can't be decorated."); } other.descriptor = element.descriptor; } else { if (_hasDecorators(element)) { if (_hasDecorators(other)) { throw new ReferenceError("Decorators can't be placed on different accessors with for " + "the same property (" + element.key + ")."); } other.decorators = element.decorators; } _coalesceGetterSetter(element, other); } } else { newElements.push(element); } } return newElements; }

function _hasDecorators(element) { return element.decorators && element.decorators.length; }

function _isDataDescriptor(desc) { return desc !== undefined && !(desc.value === undefined && desc.writable === undefined); }

function _optionalCallableProperty(obj, name) { var value = obj[name]; if (value !== undefined && typeof value !== "function") { throw new TypeError("Expected '" + name + "' to be a function"); } return value; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import RdfResourceImpl, { namespace, property } from '@tpluscode/rdfine';
import { createFactory } from '@tpluscode/rdfine/factory';
import * as $rdf from '@rdf-esm/data-model';
import { schema } from "./namespace.mjs";
import { ThingMixin } from "./Thing.mjs";
export function CreativeWorkMixin(Resource) {
  let CreativeWorkClass = _decorate([namespace(schema)], function (_initialize, _ThingMixin) {
    class CreativeWorkClass extends _ThingMixin {
      constructor(...args) {
        super(...args);

        _initialize(this);
      }

    }

    return {
      F: CreativeWorkClass,
      d: [{
        kind: "field",
        decorators: [property.resource()],
        key: "about",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "abstract",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "accessibilityAPI",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "accessibilityControl",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "accessibilityFeature",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "accessibilityHazard",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "accessibilitySummary",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "accessMode",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "accessModeSufficient",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "accountablePerson",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "acquireLicensePage",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "aggregateRating",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "alternativeHeadline",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "archivedAt",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "assesses",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "associatedMedia",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "audience",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "audio",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "author",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "award",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "awards",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "character",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "citation",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          path: schema.citation
        })],
        key: "citationLiteral",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "comment",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          type: Number
        })],
        key: "commentCount",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "conditionsOfAccess",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "contentLocation",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "contentRating",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          path: schema.contentRating
        })],
        key: "contentRatingLiteral",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          type: Date
        })],
        key: "contentReferenceTime",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "contributor",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "copyrightHolder",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "copyrightNotice",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          type: Number
        })],
        key: "copyrightYear",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "correction",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          path: schema.correction
        })],
        key: "correctionLiteral",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "countryOfOrigin",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "creativeWorkStatus",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "creator",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "creditText",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          type: Date,
          datatype: $rdf.namedNode('http://www.w3.org/2001/XMLSchema#date')
        })],
        key: "dateCreated",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          type: Date,
          datatype: $rdf.namedNode('http://www.w3.org/2001/XMLSchema#date')
        })],
        key: "dateModified",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          type: Date,
          datatype: $rdf.namedNode('http://www.w3.org/2001/XMLSchema#date')
        })],
        key: "datePublished",
        value: void 0
      }, {
        kind: "field",
        decorators: [property()],
        key: "discussionUrl",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "editEIDR",
        value: void 0
      }, {
        kind: "field",
        decorators: [property({
          path: schema.editEIDR
        })],
        key: "editEIDRTerm",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "editor",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "educationalAlignment",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "educationalLevel",
        value: void 0
      }, {
        kind: "field",
        decorators: [property({
          path: schema.educationalLevel
        })],
        key: "educationalLevelTerm",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "educationalUse",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "encoding",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "encodingFormat",
        value: void 0
      }, {
        kind: "field",
        decorators: [property({
          path: schema.encodingFormat
        })],
        key: "encodingFormatTerm",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "encodings",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "exampleOfWork",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          type: Date,
          datatype: $rdf.namedNode('http://www.w3.org/2001/XMLSchema#date')
        })],
        key: "expires",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "fileFormat",
        value: void 0
      }, {
        kind: "field",
        decorators: [property({
          path: schema.fileFormat
        })],
        key: "fileFormatTerm",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "funder",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "genre",
        value: void 0
      }, {
        kind: "field",
        decorators: [property({
          path: schema.genre
        })],
        key: "genreTerm",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "hasPart",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "headline",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "inLanguage",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          path: schema.inLanguage
        })],
        key: "inLanguageLiteral",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "interactionStatistic",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "interactivityType",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "interpretedAsClaim",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          type: Boolean
        })],
        key: "isAccessibleForFree",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "isBasedOn",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "isBasedOnUrl",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          type: Boolean
        })],
        key: "isFamilyFriendly",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "isPartOf",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "keywords",
        value: void 0
      }, {
        kind: "field",
        decorators: [property({
          path: schema.keywords
        })],
        key: "keywordsTerm",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "learningResourceType",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "license",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "locationCreated",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "mainEntity",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "maintainer",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "material",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "materialExtent",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          path: schema.materialExtent
        })],
        key: "materialExtentLiteral",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          path: schema.material
        })],
        key: "materialLiteral",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "mentions",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "offers",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "pattern",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "position",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "producer",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "provider",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "publication",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "publisher",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "publisherImprint",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "publishingPrinciples",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "recordedAt",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "releasedEvent",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "review",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "reviews",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "schemaVersion",
        value: void 0
      }, {
        kind: "field",
        decorators: [property({
          path: schema.schemaVersion
        })],
        key: "schemaVersionTerm",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          type: Date,
          datatype: $rdf.namedNode('http://www.w3.org/2001/XMLSchema#date')
        })],
        key: "sdDatePublished",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "sdLicense",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "sdPublisher",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "size",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal({
          path: schema.size
        })],
        key: "sizeLiteral",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "sourceOrganization",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "spatial",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "spatialCoverage",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "sponsor",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "teaches",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "temporal",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "temporalCoverage",
        value: void 0
      }, {
        kind: "field",
        decorators: [property({
          path: schema.temporalCoverage
        })],
        key: "temporalCoverageTerm",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "text",
        value: void 0
      }, {
        kind: "field",
        decorators: [property()],
        key: "thumbnailUrl",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "timeRequired",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "translationOfWork",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "translator",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "typicalAgeRange",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "usageInfo",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.literal()],
        key: "version",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "video",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "workExample",
        value: void 0
      }, {
        kind: "field",
        decorators: [property.resource()],
        key: "workTranslation",
        value: void 0
      }]
    };
  }, ThingMixin(Resource));

  return CreativeWorkClass;
}

class CreativeWorkImpl extends CreativeWorkMixin(RdfResourceImpl) {
  constructor(arg, init) {
    super(arg, init);
    this.types.add(schema.CreativeWork);
  }

}

_defineProperty(CreativeWorkImpl, "__mixins", [CreativeWorkMixin, ThingMixin]);

CreativeWorkMixin.appliesTo = schema.CreativeWork;
CreativeWorkMixin.Class = CreativeWorkImpl;
export const fromPointer = createFactory([ThingMixin, CreativeWorkMixin], {
  types: [schema.CreativeWork]
});